import * as React from "react"
import { Box, Flex, Heading, Link, Text, VStack } from "@chakra-ui/react"
import Head from "next/head"
import NextLink from "next/link"

import { withNoAuth } from "components/hoc/withNoAuth"
import { Layout } from "components/Layout"

import { RegisterForm } from "../components/RegisterForm"

function Register() {
  return (
    <VStack py={20} aria-label="Account aanmaken pagina">
      <Head>
        <title>Kunstbende - Account aanmaken</title>
      </Head>
      <VStack spacing={6}>
        <Heading w={["100%", 600]} as="h1" textAlign="center">
          Welkom bij Kunstbende!
        </Heading>
        <Text w={["100%", 500]} textAlign="center" fontSize="lg">
          Word gratis member van Kunstbende en krijg toegang tot tutorials, workshops, het prikbord en de wedstrijd!  
        </Text>
        <Box w={["100%", 400]} pt={12}>
          <RegisterForm />
          <Flex p={2} justify="space-between">
            <NextLink passHref href="/login">
              <Link>Heb je eerder meegedaan? Log hier in!</Link>
            </NextLink>
          </Flex>
        </Box>
      </VStack>
    </VStack>
  )
}
Register.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>
export default withNoAuth(Register)
